import JoinAccount from './JoinAccountModal';

export default JoinAccount;
